import axios from 'axios';

export default function (context, val) {
    window.app.$confirm('Вы действительно хотите удалить выгрузку?', 'Удаление выгрузки №' + val.Id, {
        confirmButtonText: 'Удалить',
        cancelButtonText: 'Отмена',
        type: 'info'
    }).then(() => {
        context.commit('list/remove', val);
        axios({
            method: 'post',
            url: '/tourclient/payment/removeStatement',
            data: 'id='+val.Id,
            requestId: 'tourclient/payment/removeStatement'
        }).then(r => {
            window.app.$message({
                type: 'success',
                message: 'Выгрузка удалена'
            });
        }).catch(e => {
            context.dispatch('error', e, {root: true});
        });
    }).catch(() => {
    });
}